
const getters = {
  getToken: state => {
    return state.idToken;
  },
  getUserId: state => {
    return state.userId;
  },
  getloggedState: state => {
    return state.loggedIn;
  },
  getIdmClaims: state => {
    return state.idmClaims;
  },
  getUser: state => {
    return state.user;
  },
  getExpireAt: state => {
    return state.expTime;
  },
  getSelectedDevice: state => {
    return state.selectedDevice;
  },
}

export default getters